module.exports = __webpack_public_path__ + "static/media/CAM-02.4e704cb3.webp";